module.exports = require("./sg.d.ts");